import axios from 'axios'

const API = "faqs";

const Faqs = {
    listar: (params) => axios(`${API}`,{params})
}

export default Faqs